import { Avatar, Button, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { useEffect, useState } from 'react'
import colors from '../../../constants/colors'
import CardTAG from '../../CardTAG'
import ModalTAG from '../../ModalTAG'
import SearchInput from '../../SearchInput'
import TableTAG from '../../TableTAG'
import TextareaInput from '../../TextareaInput'
import FormLayout from '../FormLayout'
import { IImmediateItentionForm } from './types'
import { IUserObject } from '../../InitialReport/ReportTriageLevel/types'
import LabelErrorTAG from '../../LabelErrorTAG'
import DividerTAG from '../../DividerTAG'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../store'
import { getOrganizationUsers } from '../../../store/users/usersSlice'
import usersSelectors from '../../../store/users/usersSelectors'
import { IUserProfile } from '../../../pages/UsersPage/constants'
import RemoveButton from '../../RemoveButton'
import {getUserRoleLabelsFromUserProfile} from '../../../utils/userRoleTypeUtils'


export const columns = [
  {
    id: 'user.username',
    label: 'Name',
    format: (value: string, row: IUserProfile) => {
      return (
        <Box sx={{ display: 'flex', gap: '2rem', alignItems: 'center' }}>
          <Avatar />
          <Typography variant='bodyBold'>
            {row?.user.first_name} {row?.user.last_name}
          </Typography>
        </Box>
      )
    },
  },
  {
    id: 'user.email',
    label: 'Email',
    format: (value: string, row: IUserProfile) => {
      return (
        <Box>
          <Typography variant='bodyRegular' color={colors.BLACK}>
            {row.user?.email}
          </Typography>
        </Box>
      )
    },
  },
  {
    id: 'user.type',
    label: 'User Type',
    format: (value: string, row: IUserProfile) => {
      return (
        <Box>
          <Typography variant='bodyRegular' color={colors.BLACK}>
            {getUserRoleLabelsFromUserProfile(row.roles)}
          </Typography>
        </Box>
      )
    },
  },
]

const getIdsFromUsers = (users: IUserProfile[]) => users.map(user => user?.id)

const ImmediateItentionForm: React.FC<IImmediateItentionForm> = ({
  register,
  messageError = '',
  handleSelect,
  selectedUsers = [],
  removeUser,
  searchValue,
  onSearchValueChange,
  selectedUsersError = '',
}) => {
  const [openModal, setOpenModal] = useState<boolean>(false)

  const organizationUsers = useSelector(usersSelectors.organizationUsers)

  const getUsers = async () => {
    dispatch(getOrganizationUsers({ searchValue, excludeLoggedUser: true, onlyAssignable: true}))
    setOpenModal(true)
  }

  useEffect(() => {
    dispatch(getOrganizationUsers({ searchValue, excludeLoggedUser: true, onlyAssignable: true}))
  }, [])

  const selectedUsersColumns = [
    {
      id: 'user.username',
      label: 'Name',
      format: (value: string, row: IUserProfile) => {
        return (
          <Box sx={{ display: 'flex', gap: '2rem', alignItems: 'center' }}>
            <Avatar />
            <Typography variant='bodyBold'>
              {row?.user.first_name} {row?.user.last_name}
            </Typography>
          </Box>
        )
      },
    },
    {
      id: 'actions',
      label: '',
      align: 'right',
      format: (_: any, row: IUserObject) => {
        return (
          <RemoveButton
            tooltipMessage='Remove User'
            removeFunctionHandler={() => {
              removeUser(row.id)
            }}
          />
        )
      },
    },
  ]

  const dispatch = useDispatch<AppDispatch>()

  const renderSelectedUsers = () => {
    return <TableTAG pagination={false} columns={selectedUsersColumns} rows={selectedUsers} />
  }
  return (
    <>
      <FormLayout>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            width: '100%',
            alignItems: 'start',
          }}
        >
          {selectedUsersError && <LabelErrorTAG error={selectedUsersError} label='SelectedUsers' />}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <p>Choose User</p>
            <Button
              variant='outlined'
              sx={{ borderRadius: '1rem', border: '1px solid black !important', height: '50%' }}
              onClick={() => {
                getUsers()
              }}
            >
              <Typography variant='bodyRegular' sx={{ textTransform: 'none', color: colors.BLACK }}>
                Add Person
              </Typography>
            </Button>
          </div>

          {selectedUsers?.length !== 0 && renderSelectedUsers()}
        </Box>

        <TextareaInput
          label='User Message'
          minRows={5}
          placeholder='Write a brief message to the user you’ll be transferring the case to.'
          register={register}
          fieldName={'message'}
          error={messageError}
        />
      </FormLayout>
      <ModalTAG open={openModal} style={{ width: { xs: '90%', xl: '70%' } }}>
        <CardTAG
          title='Add Person'
          closable={true}
          closeCard={() => {
            setOpenModal(false)
          }}
        >
          <FormLayout>
            <Box sx={{ display: 'flex', gap: '1rem', width: '100%', alignItems: 'end' }}>
              <SearchInput
                label='User Search'
                value={searchValue}
                onValueChange={onSearchValueChange}
                placeholder='Enter an EIN or name here to begin searching'
              />
              <Button
                variant='outlined'
                sx={{
                  borderRadius: '1rem',
                  border: '1px solid black !important',
                  height: '50%',
                }}
                disabled={!searchValue}
              >
                <Typography
                  variant='bodyRegular'
                  sx={{ textTransform: 'none' }}
                  onClick={() => {
                    getUsers()
                  }}
                >
                  Search
                </Typography>
              </Button>
            </Box>
            <DividerTAG />
            <Box sx={{ maxHeight: '40vh', overflow: 'hidden', paddingBottom: '1.8rem' }}>
              <TableTAG
                columns={columns}
                rows={organizationUsers}
                onRowClick={handleSelect}
                selectedRows={getIdsFromUsers(selectedUsers)}
                pagination={false}
              />
            </Box>
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
              <Button
                variant='submitFormButton'
                sx={{ width: '20%' }}
                onClick={() => {
                  setOpenModal(false)
                }}
              >
                <Typography variant='bodyBold'>Confirm</Typography>
              </Button>
            </Box>
          </FormLayout>
        </CardTAG>
      </ModalTAG>
    </>
  )
}

export default ImmediateItentionForm
